import { SimpleResult } from "../dto";
import { Api, getCompanyId } from "../helpers";
import { RydeUiUnit } from "../models";

export class EntitiesRecordAvailabilityApi {
  static async check(params: {
    entity: RydeUiUnit;
    recordId: number;
  }): Promise<{ isRecordAvailable: boolean }> {
    const companyId = getCompanyId();
    if (!companyId) {
      return { isRecordAvailable: false };
    }

    const response = await Api.get<
      SimpleResult<{ isRecordAvailable: boolean }>
    >(`/api/v1/core/c/${companyId}/entities/record_availability`, {
      entity: params.entity,
      id: String(params.recordId),
    });

    const result = response?.data;
    if (result?.success && result.data) {
      return { isRecordAvailable: Boolean(result.data.isRecordAvailable) };
    }

    return { isRecordAvailable: false };
  }
}
